//React
import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
//Custom
import { useAuth } from '../contexts/AuthContext'
import { useDashboard } from '../contexts/DashboardContext'

//Material UI
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

export default function Login() {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const { login } = useAuth()
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const history = useHistory()
    const {setNavigationComponent} = useDashboard();

    async function handleSubmit(e) {
        e.preventDefault()
        try {
            setError('')
            setLoading(true)
            await login(email, password)
            setNavigationComponent('home');
            history.push('/')
        } catch {
            setError('Failed to sign in')
        }
        setLoading(false)
    }

    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant="h2" align="center">
                        Log In
                    </Typography>
                    {error && <Alert severity="error">{error}</Alert>}
                    <Box
                        component="form"
                        sx={{
                            '& .MuiTextField-root': { m: 1, width: '90%' },
                        }}
                        noValidate
                        autoComplete="off"
                    >
                        <TextField
                            id="email"
                            label="Email"
                            value={email}
                            required
                            variant="standard"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            id="password"
                            label="Password"
                            type="password"
                            value={password}
                            required
                            variant="standard"
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={loading}
                            className="w-100 "
                            type="submit"
                        >
                            Log In
                        </Button>
                    </Box>
                    <Typography align="center">
                        <Link to="/forgot-password">Forgot Password?</Link>
                    </Typography>
                </CardContent>
            </Card>
            <Typography align="center">
                Need an account? <Link to="/signup">Sign Up</Link>
            </Typography>
        </>
    )
}
